module.exports = __webpack_public_path__ + "tt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tt.svg
// module id = 854
// module chunks = 0